import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { CourseOfStudyDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-courseofstudy-view',
  templateUrl: './courseofstudy-view.component.html',
  styleUrls: ['./courseofstudy-view.component.css'],
})
export class CourseofstudyViewComponent implements OnInit {
  @Input() courseOfStudies: CourseOfStudyDto[];
  courseOfStudyForm: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<CourseOfStudyDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  selectedCourseOption: any;
  filteredDelete: Array<any> = [];
  loading = true;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.courseOfStudyForm = this.fb.group({
      CourseOfStudies: this.fb.array([]),
    });
    this.setCourseOfStudy();
  }

  // method to display countries
  setCourseOfStudy() {
    const control = this.courseOfStudyForm.controls
      .CourseOfStudies as FormArray;
    this.courseOfStudies.forEach((e) => {
      control.push(
        this.fb.group({
          CourseOfStudyName: e.CourseOfStudyName,
          id: e.id,
        })
      );
    });
  }

  // method to add Country
  addCourseOfStudy() {
    const control = this.courseOfStudyForm.controls
      .CourseOfStudies as FormArray;
    control.insert(
      0,
      this.fb.group({
        CourseOfStudyName: ['', Validators.required],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteCourseOfStudy(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.courseOfStudyForm.controls
          .CourseOfStudies as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.courseOfStudies.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.courseOfStudies[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'courseOfStudy';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('courseOfStudy');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
